import {API_HOST, API_URL} from "../../constants/axios";
import axios from "axios";

const instance = axios.create({
  baseURL: API_HOST,
});

export const generateProduct = async (url) => {
  try {
    return await instance.post(API_URL.TUTORIAL_PRODUCT_GENERATION, {
      url: url
    });
  } catch (e) {
    return e.response;
  }
};

export const generateMessage = async (id, topic) => {
  try {
    return await instance.post(API_URL.TUTORIAL_MESSAGE_GENERATION, {
      id: id,
      topic: topic
    });
  } catch (e) {
    return e.response;
  }
};

export const saveProductInfo = async (id, product) => {
  return await instance.post(`${API_URL.TUTORIAL_PRODUCT_INFO.replace("{id}", id)}`, product)
}